import { nanoid } from "@reduxjs/toolkit"
import CustomButton from "common/components/Button/Button"
import { newDocumentoSettingsSelector } from "features/Crear/redux/selectors/newDocumentoSettingsSelectors"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { capitalize } from "lodash"
import { useCallback } from "react"
import { useTranslation } from "react-i18next"
import {
  setShowDescuento,
  setShowDescuentoModal,
  setShowDiasPago,
  setShowDiasPagoModal,
  setShowFechaOperacion,
  setShowFechaOperacionModal,
  setShowFormaPago,
  setShowFormaPagoModal,
  setShowLogo,
  setShowLogoModal,
  setShowObservaciones,
  setShowObservacionesModal,
  setShowRetencion,
  setShowRetencionModal,
} from "../../redux/slices/newDocumentoSettingsSlice"
import {
  recalculate,
  setDescuento,
  setRetencionPorcentaje,
  setRetencionTipoId,
} from "../../redux/slices/newDocumentoSlice"
import InputSwitchSetting from "./InputSwitchSetting"

const DocumentoSettingsNuevosCampos = ({
  sinValorar,
  setSinValorar,
  titleDocumento,
  observacionCesion,
  typeDocumento,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const {
    showRetencion,
    showLogo,
    showDescuento,
    showFechaOperacion,
    showFormaPago,
    showDiasPago,
    showObservaciones,
  } = useSelector(newDocumentoSettingsSelector)

  const getInputs = useCallback(() => {
    return [
      {
        name: `${t("crear.facturaRec.settings.addLogoLabel")}`,
        checked: showLogo,
        setFuntion: setShowLogoModal,
        onHideFuntions: [[setShowLogo, false]],
      },
      {
        name: `${t("crear.facturaRec.settings.operationDateLabel")}`,
        checked: showFechaOperacion,
        setFuntion: setShowFechaOperacionModal,
        onHideFuntions: [[setShowFechaOperacion, false]],
      },
      {
        name: `${t("crear.facturaRec.settings.discountLabel")}`,
        checked: sinValorar ? false : showDescuento,
        disabled: sinValorar,
        setFuntion: setShowDescuentoModal,
        onHideFuntions: [
          [setShowDescuento, false],
          [setDescuento, 0],
          [recalculate],
        ],
      },
      {
        name: `${t("crear.facturaRec.settings.retencionLabel")}`,
        checked: sinValorar ? false : showRetencion,
        disabled: sinValorar,
        setFuntion: setShowRetencionModal,
        onHideFuntions: [
          [setShowRetencion, false],
          [setRetencionTipoId, 0],
          [setRetencionPorcentaje, 0],
          [recalculate],
        ],
      },
      {
        name: `${t("crear.facturaRec.settings.observationLabel")}`,
        checked: showObservaciones || observacionCesion,
        disabled: observacionCesion,
        setFuntion: setShowObservacionesModal,
        onHideFuntions: [[setShowObservaciones, false]],
      },
      {
        name: `${t("crear.facturaRec.settings.paymentFormLabel")}`,
        checked: showFormaPago,
        setFuntion: setShowFormaPagoModal,
        onHideFuntions: [[setShowFormaPago, false]],
      },
      {
        name: `${t("crear.facturaRec.settings.paymentDayLabel")}`,
        checked: showDiasPago,
        setFuntion: setShowDiasPagoModal,
        onHideFuntions: [[setShowDiasPago, false]],
      },
      {
        name: `${capitalize(titleDocumento)}${t(
          "crear.facturaRec.settings.notValorateLabel"
        )}`,
        checked: sinValorar,
        hide:
          typeDocumento ===
            `${t("crear.facturaRec.settings.invoceNormalLabel")}` ||
          typeDocumento ===
            `${t("crear.facturaRec.settings.recurrentInvoceLabel")}`,
        setFuntion: setSinValorar,
        noDispatch: true,
      },
    ]
    // eslint-disable-next-line prettier/prettier
  }, [
    observacionCesion,
    setSinValorar,
    showDescuento,
    showDiasPago,
    showFechaOperacion,
    showFormaPago,
    showLogo,
    showObservaciones,
    showRetencion,
    sinValorar,
    t,
    titleDocumento,
    typeDocumento,
  ])

  return (
    <div className='p-0 mt-5 text-left col'>
      <h5 className='h5 font-weight-500'>
        {t("crear.facturaRec.settings.newFieldLabel")}
      </h5>

      <div className='p-2 col'>
        {getInputs().map((input) => {
          return (
            <InputSwitchSetting
              key={nanoid()}
              {...input}
            />
          )
        })}

        <CustomButton
          // @ts-expect-error TS(2345): Argument of type...
          onClick={() => dispatch(setShowAlbaranLogisticoPage(true))}
          className='!tw-bg-secondary hover:!tw-bg-secondary-over !tw-border-none tw-w-full'
        >
          {t("crear.facturaRec.settings.organizePackingLabel")}
        </CustomButton>
      </div>
    </div>
  )
}

export default DocumentoSettingsNuevosCampos
